import { mountImageBatch } from './image-batch-queue.js';
import { canvasToBlob, imageExtension, imageIsAr, imageName, makeCanvas, openBitmap } from './image-batch-utils.js';
import { trackEvent } from '../core/analytics.js';

const t = (ar, en) => imageIsAr ? ar : en;
const fields = [
  {
    key: 'format',
    label: t('صيغة الإخراج الحديثة', 'Output format'),
    type: 'select',
    default: 'image/webp',
    options: [
      { value: 'image/webp', label: 'WebP (الأنسب لتوافق الويب والأداء)' },
      { value: 'image/avif', label: 'AVIF (أعلى نسبة ضغط فائقة الحداثة)' }
    ]
  },
  {
    key: 'autoQuality',
    label: t('جودة التحويل', 'Conversion quality'),
    type: 'select',
    default: 'auto',
    options: [
      { value: 'auto', label: t('تلقائي ذكي (موصى به - توازن الحجم والوضوح)', 'Smart Auto (Recommended - optimal clarity & size)') },
      { value: 'custom', label: t('تخصيص يدوي للنسبة %', 'Custom percentage %') }
    ]
  },
  {
    key: 'quality',
    label: t('جودة الصورة %', 'Image Quality %'),
    type: 'range',
    min: 10,
    max: 100,
    step: 1,
    default: 100,
    suffix: '%',
    showIf: (s) => s.autoQuality === 'custom'
  }
];

mountImageBatch({
  rootId: 'converter-app', fields, zipName: 'converted-images.zip',
  process: async (file, settings, report) => {
    report(10, t('جارٍ فك تشفير الصورة محلياً', 'Decoding image locally'));
    const bitmap = await openBitmap(file);
    const width = bitmap.width; const height = bitmap.height;
    const type = settings.format || 'image/webp';
    // Always preserve transparency for WebP and AVIF (no opaque background fill)
    const { canvas, context } = makeCanvas(width, height, null);
    context.drawImage(bitmap, 0, 0); bitmap.close();
    report(55, t('جارٍ التحويل إلى الصيغة الحديثة', 'Encoding next-gen format'));
    
    // Auto quality: optimal balance (0.85 for WebP, 0.80 for AVIF) preserving full clarity and maximum compression
    let qualityNum = 0.85;
    if (settings.autoQuality === 'custom' && settings.quality !== undefined) {
      qualityNum = Math.max(0.1, Math.min(1.0, Number(settings.quality) / 100));
    } else {
      qualityNum = type === 'image/avif' ? 0.80 : 0.85;
    }

    const blob = await canvasToBlob(canvas, type, qualityNum);
    const ext = imageExtension(blob.type);
    const notice = blob.type !== type ? ` · ${t('تم استخدام التنسيق المدعوم', 'used supported format')}: ${ext.toUpperCase()}` : '';
    report(100, t('اكتمل التحويل بنجاح', 'Conversion complete'));
    const outFilename = `${imageName(file.name)}.${ext}`;
    return { blob, filename: outFilename, details: `${width} × ${height} px${notice}` };
  }
});
